import { useNavigate, useLocation } from "react-router-dom";
import { CreateSchedulePage as CreateSchedulePageView } from "@/components/CreateSchedulePage";
import type { components } from "@dolfin/api-admin";

type ExtractedContractTerms = components["schemas"]["ExtractedContractTerms"];

export function CreateSchedulePage() {
  const navigate = useNavigate();
  const location = useLocation();
  // Set by the schedules list page after a contract upload (see onContractExtracted).
  const contractTerms = (location.state as { contractTerms?: ExtractedContractTerms } | null)
    ?.contractTerms;

  return (
    <CreateSchedulePageView
      onCreated={(id) => navigate(`/schedules/${id}`)}
      onCancel={() => navigate("/schedules")}
      extractedTerms={contractTerms}
    />
  );
}
